// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'user-plane';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M16.969 16.706v-5.312a1.063 1.063 0 0 0-1.063-1.063H2.094a1.063 1.063 0 0 0-1.063 1.063v5.312m6.106-13.55a1.863 1.863 0 1 0 3.726 0 1.863 1.863 0 0 0-3.726 0zm4.519 5.313a2.125 2.125 0 0 0-2.125-2.125H8.47a2.125 2.125 0 0 0-2.125 2.125' />
    <path d='m6.195 16.02 1.112.651 4.703-2.656m-1.983 1.119L7.4 13.427' />
  </g>
);

export const viewBox = '0 0 18 18';
